import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { TipsState, TipState, TipsApiResponse } from '../types';

const initialState: TipsState = {
  tips: [],
};

const tipSlice = createSlice({
  name: 'tips',
  initialState,
  reducers: {
    setTipsAction(state, action: PayloadAction<TipsApiResponse>) {
      state.tips = action.payload.tips;
    },
  },
});

export const { setTipsAction } = tipSlice.actions;

export const getTips = (state: RootState): TipState[] => state.tips.tips;

export default tipSlice.reducer;
